import { parse } from "querystring";

import { Trans } from "@lingui/macro";
import {
  Banner,
  BannerStatus,
  BannerVariant,
  BannerLeftAccessoryType,
  Space,
} from "@gocardless/flux-react";

export const RedirectMessage = () => {
  if (!shouldDisplay()) return null;
  return (
    <>
      <Space v={1} />
      <Banner
        variant={BannerVariant.Light}
        leftAccessory={{
          type: BannerLeftAccessoryType.Status,
          status: BannerStatus.Warning,
        }}
        title=""
      >
        <Trans id="sign-in-page.gc4x-redirect-message">
          You are seeing this screen because in order to access GoCardless for
          Xero, you need to sign in to GoCardless and set up 2-factor
          authentication.
        </Trans>
      </Banner>
    </>
  );
};

const shouldDisplay = () => {
  const { redirect } = parse(window.location.search.split("?")[1] || "");
  return redirect && redirect.includes("enforce-mfa-redirect=gc4x");
};
